// Shared presentation components of the CRM26 restyling. See /dev/components for a live overview.
import {AvatarStackComponent} from './avatar/avatar-stack.component';
import {AvatarComponent} from './avatar/avatar.component';
import {BreadcrumbsComponent} from './breadcrumbs/breadcrumbs.component';
import {CheckStripComponent} from './check-strip/check-strip.component';
import {ClientPathComponent} from './client-path/client-path.component';
import {DataListComponent} from './data-list/data-list.component';
import {DataRowComponent} from './data-list/data-row.component';
import {DayGroupComponent} from './data-list/day-group.component';
import {EmptyStateComponent} from './empty-state/empty-state.component';
import {EnvBadgeComponent} from './env-badge/env-badge.component';
import {FieldComponent} from './field/field.component';
import {FilterChipsComponent} from './filter-chips/filter-chips.component';
import {FilterTilesComponent} from './filter-tiles/filter-tiles.component';
import {IconTileComponent} from './icon-tile/icon-tile.component';
import {InfoBannerComponent} from './info-banner/info-banner.component';
import {KbdComponent} from './kbd/kbd.component';
import {PageHeaderComponent} from './page-header/page-header.component';
import {PageComponent} from './page/page.component';
import {PauseDividerComponent} from './pause-divider/pause-divider.component';
import {PeriodStepperComponent} from './period-stepper/period-stepper.component';
import {PersonSwitcherComponent} from './person-switcher/person-switcher.component';
import {CustomerColorPipe} from '../customer-color.pipe';
import {FormatBytesPipe, FormatDurationPipe, FormatMsPipe, RelativeDayPipe} from './pipes/format.pipes';
import {HoursWeekComponent} from './hours-week/hours-week.component';
import {PrCardComponent} from './pr-card/pr-card.component';
import {TaskRowComponent} from './task-row/task-row.component';
import {TimeEntryComponent} from './time-entry/time-entry.component';
import {SectionComponent} from './section/section.component';
import {StatusBadgeComponent} from './status-badge/status-badge.component';
import {StatusDotComponent} from './status-dot/status-dot.component';
import {StickySaveBarComponent} from './sticky-save-bar/sticky-save-bar.component';
import {TabGroupComponent} from './tab-group/tab-group.component';
import {ThresholdBarComponent} from './threshold-bar/threshold-bar.component';

export * from './ui-colors';
export * from '../customer-color';
export * from './pipes/format';
export type {FilterOption} from './filter-chips/filter-chips.component';
export type {TabOption} from './tab-group/tab-group.component';
export type {Person} from './person-switcher/person-switcher.component';
export type {CheckStripItem, CheckStripTone} from './check-strip/check-strip.component';
export type {HoursDay} from './hours-week/hours-week.component';
export type {PrReviewer, PrWorkItem} from './pr-card/pr-card.component';
export type {TaskOwner, TaskPathPart, TaskPriority, TaskStatusTone} from './task-row/task-row.component';
export {TASK_STATES, taskStatusDot, taskStatusTone} from './task-row/task-row.component';
export {
    AvatarComponent,
    AvatarStackComponent,
    BreadcrumbsComponent,
    CheckStripComponent,
    ClientPathComponent,
    CustomerColorPipe,
    DataListComponent,
    DataRowComponent,
    DayGroupComponent,
    EmptyStateComponent,
    EnvBadgeComponent,
    FieldComponent,
    FilterChipsComponent,
    FilterTilesComponent,
    FormatBytesPipe,
    FormatDurationPipe,
    FormatMsPipe,
    HoursWeekComponent,
    IconTileComponent,
    InfoBannerComponent,
    KbdComponent,
    PageComponent,
    PageHeaderComponent,
    PauseDividerComponent,
    PeriodStepperComponent,
    PersonSwitcherComponent,
    PrCardComponent,
    RelativeDayPipe,
    SectionComponent,
    StatusBadgeComponent,
    StatusDotComponent,
    StickySaveBarComponent,
    TabGroupComponent,
    TaskRowComponent,
    ThresholdBarComponent,
    TimeEntryComponent,
};

/** Everything at once: `imports: [...UI]`. */
export const UI = [
    AvatarComponent,
    AvatarStackComponent,
    BreadcrumbsComponent,
    CheckStripComponent,
    ClientPathComponent,
    CustomerColorPipe,
    DataListComponent,
    DataRowComponent,
    DayGroupComponent,
    EmptyStateComponent,
    EnvBadgeComponent,
    FieldComponent,
    FilterChipsComponent,
    FilterTilesComponent,
    FormatBytesPipe,
    FormatDurationPipe,
    FormatMsPipe,
    HoursWeekComponent,
    IconTileComponent,
    InfoBannerComponent,
    KbdComponent,
    PageComponent,
    PageHeaderComponent,
    PauseDividerComponent,
    PeriodStepperComponent,
    PersonSwitcherComponent,
    PrCardComponent,
    RelativeDayPipe,
    SectionComponent,
    StatusBadgeComponent,
    StatusDotComponent,
    StickySaveBarComponent,
    TabGroupComponent,
    TaskRowComponent,
    ThresholdBarComponent,
    TimeEntryComponent,
] as const;
